// This icon file is generated automatically.
var PTrademarkOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8zm1.37-5.23a1.9 1.9 0 001.22-1.86c0-1.11-.7-2.05-2.25-2.05H4.9a.13.13 0 00-.13.13v6.4c0 .07.06.13.13.13h.85c.07 0 .12-.06.12-.13V7.77h1.39l1.16 2.49c.02.04.07.07.12.07h.97l.05-.01c.06-.04.09-.1.06-.17L8.37 7.58zM7.16 6.9H5.88V4.58h1.3c.76 0 1.27.4 1.27 1.18 0 .73-.47 1.13-1.3 1.13z", "fill-rule": "nonzero" } }] }, "name": "p-trademark", "theme": "outlined" };
export default PTrademarkOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PTrademarkOutlined.js
// module id = 3695
// module chunks = 0